
import React, { useState } from "react";

import "./Style/StudentFeedback.css";

import TopNavbar from "../home/TopNavbar";

import { API_CONFIG } from './../config'; 

const CREATE_USER_CONTACT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.STUDENTFEEDBACK}`;

const StudentFeedback = () => {
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // Get student details from localStorage
  const phoneFromStorage = localStorage.getItem("userPhone") || "";
  const emailFromStorage = localStorage.getItem("userEmail") || "";
  const nameFromStorage = localStorage.getItem("userName") || "";

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate rating
    if (rating === 0) {
      alert("Please select a star rating.");
      return;
    }

    // Validate feedback
    if (feedback.trim() === "") {
      alert("Please write your feedback.");
      return;
    }

    // Prepare feedback data
    const feedbackData = {
      name: nameFromStorage,
      phone: phoneFromStorage,
      email: emailFromStorage,
      rating: rating,
      feedback: feedback.trim(),
    };

    console.log("Feedback:", feedbackData);

    try {
      setLoading(true);

      const response = await fetch(CREATE_USER_CONTACT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(feedbackData),
      });

      const data = await response.json();

      console.log("API Response:", data);

      if (response.ok) {
        setSubmitted(true);
      } else {
        alert(data.message || "Unable to submit feedback. Please try again.");
      }
    } catch (error) {
      console.error("Feedback submission error:", error);

      alert(
        "Unable to submit your feedback. Please check your internet connection and try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAnotherFeedback = () => {
    setSubmitted(false);
    setRating(0);
    setFeedback("");
  };

  return (
    <div className="feedback-page">

      <TopNavbar name="Your Feedback" />

      <div className="feedback-container">

        <div className="feedback-header">
          <h1>Share Your Feedback</h1>

          <p>
            Your feedback helps us improve the NEET PREP APP
            and provide better study content for students.
          </p>
        </div>

        {submitted ? (
          <div className="feedback-success">

            <div className="success-icon">
              ✅
            </div>

            <h2>Thank You!</h2>

            <p>
              Your feedback has been submitted successfully.
              We appreciate your valuable feedback.
            </p>

           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <br></br>
           <br></br>

          </div>
        ) : (

          <form
            onSubmit={handleSubmit}
            className="feedback-form"
          >

            {/* Star Rating */}

            <div className="rating-section">

              <label>
                How would you rate our study content?
              </label>

              <div className="stars">

                {[1, 2, 3, 4, 5].map((star) => (

                  <button
                    type="button"
                    key={star}
                    className={`star ${
                      star <= rating ? "selected" : ""
                    }`}
                    onClick={() => setRating(star)}
                    aria-label={`${star} star`}
                  >
                    ★
                  </button>

                ))}

              </div>

              <div className="rating-text">

                {rating === 0 && "Select your rating"}
                {rating === 1 && "Very Poor"}
                {rating === 2 && "Poor"}
                {rating === 3 && "Average"}
                {rating === 4 && "Good"}
                {rating === 5 && "Excellent"}

              </div>

            </div>


            {/* Feedback */}

            <div className="feedback-form-group">

              <label htmlFor="feedback">
                Your Feedback <span>*</span>
              </label>

              <textarea
                id="feedback"
                rows="6"
                placeholder="Tell us what you think about our app, content, and features and how to improve our app, what feature, content you want..."
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                disabled={loading}
              />

            </div>


            {/* Submit Button */}

            <button
              type="submit"
              className="submit-feedback-btn"
              disabled={loading}
            >

              {loading
                ? "Submitting..."
                : "⭐ Submit Feedback"}

            </button>

          </form>

        )}

        <br />
        <br />
        <br />
        <br />
        <br></br>
        <br></br>

      </div>

    </div>
  );
};

export default StudentFeedback;
